module.exports = __webpack_public_path__ + "media/subtotal gastrectomy.fe248f67.wav";